import { NavLink } from 'react-router-dom'
import styled from 'styled-components/macro'

export const IconWrapper = styled.span`
  display: flex;
  width: 20rem;
  cursor: pointer;
  transition: color 0.3s ease-in-out;
`

export const StyledLink = styled(NavLink)`
  position: relative;
  padding: 1rem 1.2rem;
  width: 100%;
  max-width: 22.8rem;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  color: ${(props) => props.theme.color.text};
  transition: none;
  &:hover {
    color: ${(props) => props.theme.color.default};
  }
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    max-width: 30.1rem;
    border-right: 0.1rem solid  ${props.theme.color.elementBorder};
  `};
  ${(props) => props.theme.breakpoints.greaterThan('mdMax')`
    padding: 1.4rem 1.6rem;
    max-width: 30rem;
    border-right: none;
  `};
`

export const LogoSpan = styled.span`
  display: none;
`

export const IconWeb = styled.span`
  position: absolute;
  right: 0;
  display: none;
  width: 3rem;
  height: 3rem;
  transition: color 0.3s ease-in-out;
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    display: block;
  `};
`
